<template>
    <v-dialog v-model="show" v-if="challenge" persistent max-width="80%" scrollable >
      <v-card>
        <v-card-title><h2>Challenge Editor</h2></v-card-title>
        <v-divider/>
        <v-card-text style="height: 80%">
          <v-container fluid>
            <v-row>
              <v-col>
                <v-card>
                  <v-card-title>Challenge</v-card-title>
                  <v-container fluid>
                    <v-row class="pt-2">
                      <v-col cols="2"><v-select label="Type" :items="['RACE', 'TIME_TRIAL']" v-model="challenge.type" dense/></v-col>
                      <v-col><v-text-field required label="Name" v-model="challenge.name" dense/></v-col>
                      <v-col cols="3"><v-switch label="Active" v-model="challenge.active" dense></v-switch></v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <v-container fluid class="pa-0">
                          <v-row align="center">
                            <v-col><v-switch label="Engine allowed" v-model="challenge.allowEngine" dense></v-switch></v-col>
                            <v-col class="mt-4"><v-slider label="Participants" max="10" min="1" :value="challenge.maximumBoats" thumb-label="always" dense /></v-col>
                             <v-col>
                              <v-menu max-width="290">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-text-field :value="challengeStartDateUtc" label="Challenge Date" readonly v-bind="attrs" v-on="on" dense />
                                </template>
                                <v-date-picker v-model="challengeStartDateUtc" />
                              </v-menu>
                            </v-col>
                            <v-col>
                              <v-menu max-width="290">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-text-field :value="challengeStartTimeUtc" label="Challenge Time" readonly v-bind="attrs" v-on="on" dense />
                                </template>
                                <v-time-picker v-model="challengeStartTimeUtc" format="24hr" />
                              </v-menu>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-col>
                    </v-row>
                  </v-container>
                  <v-textarea class="px-3 ma-auto" label="Challenge description" v-model="challenge.description" rows="1" auto-grow autocomplete />
                </v-card>
              </v-col>
              <v-col>
                <v-card>
                  <v-card-title>Course</v-card-title>
                  <v-container fluid>
                    <v-row>
                      <v-col cols="2"><v-select label="Selector" :items="['New', 'My Courses', 'All Courses']" v-model="courseSelector" @change="updateCourses" dense /></v-col>
                      <v-col><v-select label="Course" :items="availableCoursesSelectorItems" v-model="selectedCourse" :disabled="courseSelector==='New'" @change="selectCourse" dense /></v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="2"><v-select label="Type" :items="['RACE', 'PASSAGE']" v-model="challenge.course.type" dense/></v-col>
                      <v-col><v-text-field required label="Name" v-model="challenge.course.name" dense /></v-col>
                    </v-row>
                  </v-container>
                  <v-textarea class="px-3 ma-auto" label="Course description" v-model="challenge.course.description" rows="1" auto-grow autocomplete />
                </v-card>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-card>
                  <v-card-subtitle>Course Items</v-card-subtitle>
                  <v-container fluid>
                    <v-row>
                      <v-col cols="8"><v-data-table dense :headers="courseItemTableHeaders" :items="challenge.course.courseItems" :items-per-page=10000 hide-default-footer /></v-col>
                      <v-col><GMap v-if="challenge.course.courseItems.length > 0" :challenge="challenge" style="width: 100%; padding-top: 100%;" v-on:marker-dragged="updateCourseItemPosition($event)"/></v-col>
                    </v-row>
                  </v-container>
                </v-card>
              </v-col>
            </v-row>
          </v-container>

        </v-card-text>
        <v-divider/>
        <v-card-actions>
          <v-spacer/>
          <v-btn color="blue darken-1" text @click="$emit('dialog-close')">Close</v-btn>
          <v-btn color="blue darken-1" text @click="saveChallenge">Save</v-btn>
        </v-card-actions>
        <v-alert class="mx-2" dense type="error" v-if="saveError">{{saveError}}</v-alert>
      </v-card>
    </v-dialog>
</template>

<script>
import {eSailServerAuth} from "@/plugins/axios";
import _ from "lodash";
import moment from "moment";
import GMap from '../GMap';

export default {
  name: "ChallengeEditor",
  props: {
    item: null,
  },
  components: {
    GMap
  },
  data: () => ({
    show: true,
    challenge: null,
    courseSelector: 'New',
    selectedCourse: null,
    availableCourses: [],
    availableCoursesSelectorItems: [],
    saveError: null,
    courseItemTableHeaders: [
      {text: 'Id', value: 'sequenceNo'},
      {text: 'Type', value: 'itemType'},
      {text: 'Side', value: 'markerSide'},
      {text: 'Message', value: 'message'},
      {text: 'Latitude', value: 'latitude'},
      {text: 'longitude', value: 'longitude'},
      {text: 'Rotation', value: 'rotation'}
    ]
  }),
  computed: {
    challengeStartDateUtc: {
      get() {
        return moment(this.challenge.startTimeUtc).format('yyyy-MM-DD')
      },
      set(newVal) {
        const time = moment(this.challenge.startTimeUtc).format('HH:mm')
        this.challenge.startTimeUtc = moment(newVal + ' ' + time)
      }
    },
    challengeStartTimeUtc: {
      get() {
        return moment(this.challenge.startTimeUtc).format('HH:mm')
      },
      set(newVal) {
        const date = moment(this.challenge.startTimeUtc).format('yyyy-MM-DD')
        this.challenge.startTimeUtc = moment(date + ' ' + newVal)
      }
    }
  },
  mounted() {
    this.challenge = this.item
    if (!this.challenge) {
      this.challenge = {
        name: "New Challenge",
        description: "",
        type: "RACE",
        startTimeUtc: moment().add(12, 'hours'),
        maximumLength: 1000,
        maximumBoats: 10,
        active: true,
        course: this.createDummyCourse()
      }
    }
  },
  methods: {
    createDummyCourse() {
      return {
        name: "New Course",
        description: "",
        type: "RACE",
        courseItems: [{
          "itemType": "START_LINE",
          "message": "Start Line",
          "sequenceNo": 1,
          "rotation": 0.0,
          "markerSide": "NONE",
          "latitude": 46.7,
          "longitude": -28.09
        },
          {
            "itemType": "START_LINE",
            "message": "Start Line",
            "sequenceNo": 2,
            "rotation": 0.0,
            "markerSide": "NONE",
            "latitude": 46.69,
            "longitude": -28.09
          },
          {
            "itemType": "COURSE_MARKER",
            "message": "Marker",
            "sequenceNo": 3,
            "rotation": 180,
            "markerSide": "PORT",
            "latitude": 46.695,
            "longitude": -28.07
          },
          {
            "itemType": "FINISH_LINE",
            "message": "Finish Line",
            "sequenceNo": 4,
            "rotation": 0.0,
            "markerSide": "NONE",
            "latitude": 46.7,
            "longitude": -28.05
          },
          {
            "itemType": "FINISH_LINE",
            "message": "Finish Line",
            "sequenceNo": 5,
            "rotation": 0.0,
            "markerSide": "NONE",
            "latitude": 46.69,
            "longitude": -28.05
          }
        ]
      }
    },
    updateCourses() {
      let queryParam = ""
      if (this.courseSelector === 'New') {
        this.selectedCourse = null
        this.challenge.course = this.createDummyCourse()
        return
      } else if (this.courseSelector === 'My Courses') {
        queryParam = "?owner-id=" + this.$auth.user().id
      }
      eSailServerAuth.get('courses' + queryParam, { headers: { Authorization: `Bearer ` + this.$auth.token() }})
        .then(response => {
          this.availableCourses = response.data
          if (this.availableCourses.length > 0) {
            this.availableCoursesSelectorItems = _.map(this.availableCourses, item => {
              return {
                text: item.type + ": " + item.name + " (" + item.owner.username + ")",
                value: item.id
              }
            })
            this.selectedCourse = this.availableCoursesSelectorItems[0]
            this.selectCourse()
          }
        })
    },
    selectCourse() {
      if (this.selectedCourse) {
        this.challenge.course = _.find(this.availableCourses, ['id', this.selectedCourse.value ? this.selectedCourse.value : this.selectedCourse])
      }
    },
    updateCourseItemPosition(newPos) {
      console.log(newPos)
    },
    saveChallenge() {
      const promise = this.challenge.id ?
          eSailServerAuth.put('challenges', this.challenge, { headers: { Authorization: `Bearer ` + this.$auth.token() }}) :
          eSailServerAuth.post('challenges', this.challenge, { headers: { Authorization: `Bearer ` + this.$auth.token() }})
      promise.then(() => {
        this.saveError = null
        if (!this.challenge.id) {
          this.$emit('challenge-created', this.challenge)
        }
        this.$emit('dialog-close')
      })
      .catch(error => {
        this.saveError = error
      })
    }
  }
}
</script>

<style scoped>

</style>